/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountNameFilters } from '../models/AccountNameFilters';
import { AccountStatusFilters } from '../models/AccountStatusFilters';
import { CloudProviderFilters } from '../models/CloudProviderFilters';
import { FreeTextFilters } from '../models/FreeTextFilters';
import { IdFilters } from '../models/IdFilters';
import { OrganizationIdFilters } from '../models/OrganizationIdFilters';
import { ProviderAccountIdFilters } from '../models/ProviderAccountIdFilters';
import { ProviderOrganizationIdFilters } from '../models/ProviderOrganizationIdFilters';

/**
* Filter conditions. If omitted, no filtering is applied. 
*/
export class SourceAccountsFilterConditions {
  'id'?: IdFilters;
  'providerAccountId'?: ProviderAccountIdFilters;
  'accountStatus'?: AccountStatusFilters;
  'cloudProvider'?: CloudProviderFilters;
  'accountName'?: AccountNameFilters;
  'providerOrganizationId'?: ProviderOrganizationIdFilters;
  'organizationId'?: OrganizationIdFilters;
  'freeText'?: FreeTextFilters;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "IdFilters",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "ProviderAccountIdFilters",
      "format": ""
    },
    {
      "name": "accountStatus",
      "baseName": "accountStatus",
      "type": "AccountStatusFilters",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "CloudProviderFilters",
      "format": ""
    },
    {
      "name": "accountName",
      "baseName": "accountName",
      "type": "AccountNameFilters",
      "format": ""
    },
    {
      "name": "providerOrganizationId",
      "baseName": "providerOrganizationId",
      "type": "ProviderOrganizationIdFilters",
      "format": ""
    },
    {
      "name": "organizationId",
      "baseName": "organizationId",
      "type": "OrganizationIdFilters",
      "format": ""
    },
    {
      "name": "freeText",
      "baseName": "freeText",
      "type": "FreeTextFilters",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SourceAccountsFilterConditions.attributeTypeMap;
  }

  public constructor() {
  }
}

